var lx = lx || {};

lx.contact = {
    visibleInProfile: function (pId, pThis) {
        var $i = $(pThis).find('i');
        var show = ($i.hasClass("fawe-eye-slash")) ? "Y" : "N";
        lx.load.add();
        apex.server.process("contactVisible", {
                      x01: pId,
                      x02: show
                  }, {dataType: "text",
                      success: function (pData) {
                        lx.load.remove();
                        if (show == 'Y') $i.removeClass("fawe-eye-slash").addClass("fawe-eye");
                        else $i.removeClass("fawe-eye").addClass("fawe-eye-slash");
                      }
                  });
    },
    address: {
        // lx.contact.address.deleteSelected();
        deleteSelected: function (pCheck) {
                lx.load.add();
				if (pCheck) {
					apex.server.process("CollectionDeleteCheck", {
									x01: 'ADDR'
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success == 0) { 
										  lx.info.actionConfirm({type:"info",msg:lx.tran.get("DELETE_SELECTED_CHECK"), js:"$('.lxpDialog').css('display','none');",btn:"cancel"});
										}
										else {	
										  lx.info.actionConfirm({type:"warning",msg:lx.tran.get("DELETE_SELECTED"), js:"lx.contact.address.deleteSelected();"});	
										}
									}
								});
				}				
				else {				
					apex.server.process("addressDeleteSelected", {
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success) lx.info.success(d.success);
										else lx.info.error(d.err);
										//$('#pgIRaddress').trigger('apexrefresh');
										$('#pgIRaddress').trigger('apexafterclosedialog');
									}
								});
				}				
        }
    },
    bank: {
        deleteSelected: function (pCheck) {
                lx.load.add();
				if (pCheck) {
					apex.server.process("CollectionDeleteCheck", {
									x01: 'PAY'
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success == 0) { 
										  lx.info.actionConfirm({type:"info",msg:lx.tran.get("DELETE_SELECTED_CHECK"), js:"$('.lxpDialog').css('display','none');",btn:"cancel"});
										}
										else {	
										  lx.info.actionConfirm({type:"warning",msg:lx.tran.get("DELETE_SELECTED"), js:"lx.contact.bank.deleteSelected();"});	
										}
									}
								});
				}				
				else {		
					apex.server.process("bankDeleteSelected", {
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success) lx.info.success(d.success);
										else lx.info.error(d.err);
										$('#lxAccountsIR').trigger('apexafterclosedialog');
									}
								});
				}				
        }    
        
    },
    cert: {
        deleteSelected: function (pCheck) {
                lx.load.add();
				if (pCheck) {
					apex.server.process("CollectionDeleteCheck", {
									x01: 'CERT'
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success == 0) {
										  lx.info.actionConfirm({type:"info",msg:lx.tran.get("DELETE_SELECTED_CHECK"), js:"$('.lxpDialog').css('display','none');",btn:"cancel"});
										}
										else {	
										  lx.info.actionConfirm({type:"warning",msg:lx.tran.get("DELETE_SELECTED"), js:"lx.contact.cert.deleteSelected();"});	
										}
									}
								});
				}				
				else {		
					apex.server.process("certDeleteSelected", {
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success) lx.info.success(d.success);
										else lx.info.error(d.err);
										$('#Cert_IR').trigger('apexafterclosedialog');
									}
								});
				}				
        }    
        
    },
    lang: {
        deleteSelected: function (pCheck) {
                lx.load.add();
				if (pCheck) {
					apex.server.process("CollectionDeleteCheck", {
									x01: 'LANG'
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success == 0) {
										  lx.info.actionConfirm({type:"info",msg:lx.tran.get("DELETE_SELECTED_CHECK"), js:"$('.lxpDialog').css('display','none');",btn:"cancel"});
										}
										else {	
										  lx.info.actionConfirm({type:"warning",msg:lx.tran.get("DELETE_SELECTED"), js:"lx.contact.lang.deleteSelected();"});	
										}
									}
								});
				}				
				else {		
					apex.server.process("langDeleteSelected", {
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success) lx.info.success(d.success);
										else lx.info.error(d.err);
										$('#Lang_IR').trigger('apexafterclosedialog');
									}
								});
				}				
        }    
        
    },
    skill: {
        deleteSelected: function (pCheck) {
                lx.load.add();
				if (pCheck) {
					apex.server.process("CollectionDeleteCheck", {
									x01: 'SKILL'
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success == 0) {
										  lx.info.actionConfirm({type:"info",msg:lx.tran.get("DELETE_SELECTED_CHECK"), js:"$('.lxpDialog').css('display','none');",btn:"cancel"});
										}
										else {	
										  lx.info.actionConfirm({type:"warning",msg:lx.tran.get("DELETE_SELECTED"), js:"lx.contact.skill.deleteSelected();"});	
										}
									}
								});
				}				
				else {		
					apex.server.process("skillDeleteSelected", {
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success) lx.info.success(d.success);
										else lx.info.error(d.err);
										$('#Skill_IR').trigger('apexafterclosedialog');
									}
								});
				}				
        }    
        
    },
    work: {
        deleteSelected: function (pCheck) {
                lx.load.add();
				if (pCheck) {
					apex.server.process("CollectionDeleteCheck", {
									x01: 'WORK'
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success == 0) {
										  lx.info.actionConfirm({type:"info",msg:lx.tran.get("DELETE_SELECTED_CHECK"), js:"$('.lxpDialog').css('display','none');",btn:"cancel"});
										}
										else {	
										  lx.info.actionConfirm({type:"warning",msg:lx.tran.get("DELETE_SELECTED"), js:"lx.contact.work.deleteSelected();"});	
										}
									}
								});
				}				
				else {		
					apex.server.process("workexpDeleteSelected", {
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success) lx.info.success(d.success);
										else lx.info.error(d.err);
										$('#Work_IR').trigger('apexafterclosedialog');
									}
								});
				}				
        }    
        
    },
    tax: {
        deleteSelected: function (pCheck) {
                lx.load.add();
				if (pCheck) {
					apex.server.process("CollectionDeleteCheck", {
									x01: 'TAX'
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success == 0) {
										  lx.info.actionConfirm({type:"info",msg:lx.tran.get("DELETE_SELECTED_CHECK"), js:"$('.lxpDialog').css('display','none');",btn:"cancel"});
										}
										else {	
										  lx.info.actionConfirm({type:"warning",msg:lx.tran.get("DELETE_SELECTED"), js:"lx.contact.tax.deleteSelected();"});	
										}
									}
								});
				}				
				else {		
					apex.server.process("taxDeleteSelected", {
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success) lx.info.success(d.success);
										else lx.info.error(d.err);
										$('#Tax_IR').trigger('apexafterclosedialog');
									}
								});
				}				
        }    
        
    },
    tag: {
        deleteSelected: function (pCheck) {
                lx.load.add();
				if (pCheck) {
					apex.server.process("CollectionDeleteCheck", {
									x01: 'TAG'
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success == 0) {
										  lx.info.actionConfirm({type:"info",msg:lx.tran.get("DELETE_SELECTED_CHECK"), js:"$('.lxpDialog').css('display','none');",btn:"cancel"});
										}
										else {	
										  lx.info.actionConfirm({type:"warning",msg:lx.tran.get("DELETE_SELECTED_TAGS"), js:"lx.contact.tag.deleteSelected();"});	
										}
									}
								});
				}				
				else {		
					apex.server.process("tagDeleteSelected", {
								}, {dataType: 'json',
									success: function (d) {
										lx.load.remove();
										if (d.success) lx.info.success(d.success);
										else lx.info.error(d.err);
										$('#Tag_IR').trigger('apexafterclosedialog');
									}
								});
				}				
        }    
        
    },
    genCustomRo: function (pContactId, pGroup) {				
		apex.server.process("genCstFieldsRo", {
            x01: pContactId,
			x02: pGroup
		}, {
			dataType: "html",
			success: function (d) {
				if (pGroup == 'C') {
				  $("#CustomFields").html(d);
				} else if (pGroup == 'A') {
				  $("#CustomItemsA").html(d);
				} 
			}
		});
	},
    setCustom: function (pContactId, pId, pValue, pAcnId) {
		var lValue = pValue;
		apex.server.process("setCstValue", {
            x01: pContactId,
            x02: pId,
            x03: lValue,
            x04: pAcnId
		}, {
			dataType: "text",
			success: function (d) {
				/*apex.message.showPageSuccess(d);*/
				$s('P14_ERROR_MSG', d);
				if (d.length > 0) {showError("Invalid format", d);}
			}
		});
	},
	deleteContact(pContactId,pCheck) {	
		var lButtons = [];
        if (pCheck == 'Y') {
			var dialogDiv = '<div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--info t-Alert" style="margin-bottom:0rem;">'
			    + '<div class="t-Alert-wrap" style="display: block;text-align: center;"><div class="t-Alert-icon" style="padding: 3.2rem 3.2rem 1.6rem 3.2rem;">'
				+ '<span class="t-Icon" style="font-size: 4.8rem;width: 4.8rem;height: 4.8rem;"></span></div><div style="width:100%;padding:1.6rem 3.2rem 3.2rem 3.2rem;">' + lx.tran.get("DELETE_CONTACT_MSG") + '</div></div></div>';
                lButtons.push({label: lx.tran.get('YES'), js: "lx.contact.deleteContact('"+pContactId+"','N');", class: "t-Button--primary", fa:'far fawe-check'});	
                lButtons.push({label: lx.tran.get("CANCEL_BTN"), js: "$('.lxpDialog').css('display','none');", fa:'far fawe-times'});		
				lx.dialog.open({id:'DeleteCon', maxWidth: "690px", html: dialogDiv,  buttons: lButtons});
        } else {       
		apex.server.process("delContact", {
            x01: pContactId
		}, {
			dataType: "html",
			success: function (d) {
				if (d) {
					console.log(d);
				  let msg = lx.util.nvl(d.trim(),lx.tran.get("CONTACT_DELETED"));
				  var dialogDiv = '<div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--danger t-Alert" style="margin-bottom:0rem;"><div class="t-Alert-wrap" style="display: block;text-align: center;"><div class="t-Alert-icon" style="padding: 3.2rem 3.2rem 1.6rem 3.2rem;"><span class="t-Icon" style="font-size: 4.8rem;width: 4.8rem;height: 4.8rem;"></span></div><div style="width:100%;padding:1.6rem 3.2rem 3.2rem 3.2rem;">' + 
				  					msg + '</div></div></div>';
				  if ($v("pFlowStepId") == 193) {
					lButtons.push({label: lx.tran.get("CLOSE"), id: "ConBtn"+pContactId, link: "/ords/r/linxpot/lp/contacts?session="+$v("pInstance"), fa:'far fawe-times'});
				  } else {
					lButtons.push({label: lx.tran.get("CLOSE"), id: "ConBtn"+pContactId, js: "$('.lxpDialog').css('display','none');", fa:'far fawe-times'});
				  }
				    lx.dialog.open({id:'DeleteCon', maxWidth: "690px", html: dialogDiv,  buttons: lButtons});
				} else {
				  $('.lxpDialog').css('display','none');
				} 
			}
		});
        }
	}
};